

import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { SampleRequestService } from '../../../Services/SampleRequest.Service';
import { AdminService } from '../../../Services/Admin.service';
import UserProfileItem from '../../../Components/UserProfileItem';
import DetailItem from './DataItem';
import { FaSearch } from 'react-icons/fa';
import { SampleService } from '../../../Services/Sample.service';
import { Field } from 'formik';
import Loader from '../../../Components/Loader';

const InviteSpecialDonorModal = ({
    show,
    onHide,
    onConfirm,
    id,
    ismatched,
    type
}) => {
    const [donorInput, setDonorInput] = useState(null)
    const [donorDetails, setDonorDetails] = useState(null);
    const [showError, setShowError] = useState(null);

    const [loading, setLoading] = useState(false);
 

    const searchDonorByIdorEmail = async () => {
        setLoading(true);
        setSelectedSampleTypes([]); 
        try {
            if (id && donorInput) {
                if(type !== 'donor'){
                    const payload = {
                        request_id: id,   // this is donorId in case of invite donor for SR   type == 'donor'
                        search_text: donorInput
                    }
                    const response = await SampleRequestService.fetchInviteDonorDetails(payload);
                    if (response.success) {
                        setDonorDetails(response?.donors);
                        setShowError(null);
                        setLoading(false); 
                    }
                    else {
                        setDonorDetails(null);
                        setShowError(response.message);
                        setLoading(false);
    
                    } 
                }
                else{
                    const payload = {
                        donor_id: id,   // this is donorId in case of invite donor for SR   type == 'donor'
                        search_text: donorInput
                    }
                    const response = await SampleRequestService.fetchSampleDetails(payload);
                    if (response.success) {
                        setDonorDetails(response?.details);
                        setShowError(null);
                        setLoading(false); 
                    }
                    else {
                        setDonorDetails(null);
                        setShowError(response.message);
                        setLoading(false);
    
                    } 
                }
            }
            else{ 
                setShowError(`Please enter ${type!=='donor'? 'Donor ID or Email': 'Job Number'}`);
                setLoading(false);

            }
        } catch (error) { 
            console.error("Failed to duplicate sample request:", error);
            setLoading(false);

        }  
    }
    const [sampleTypes, setSampleTypes] = useState();
    useEffect(() => {

        async function fetchSampleTypes() {
            const result = await AdminService.getSampleTypes();
            setSampleTypes(result || []);
        }
        fetchSampleTypes();
    }, []);


    const handleModalClose = () => {
        setDonorDetails(null); // Clear donor details
        setShowError(null);   // Clear error
        setDonorInput(null);  // Clear input
        setSelectedSampleTypes([]);
        onHide();             // Call the provided onHide function
    };

    const [selectedSampleTypes, setSelectedSampleTypes] = useState([]);

    const handleSampleTypeChange = (sampleTypeId) => {
        setSelectedSampleTypes((prevSelected) => {
            const updatedSelection = prevSelected.includes(sampleTypeId)
                ? prevSelected.filter((id) => id !== sampleTypeId) // Remove if already selected
                : [...prevSelected, sampleTypeId]; // Add if not selected
    
            // Perform the error handling based on the new state
            

            if (updatedSelection.length > 0) {
                setShowError(null);
            } else {
                if(ismatched=="no"){ 
                    // setShowError(`${type!=='donor'?'Please select at least one sample type': 'Please choose at list one sample to assign'}`);
                    setShowError(`Please select at least one sample type ${type==='donor' && 'to assign'}`);
                }

            }
    
            return updatedSelection;
        });
    };
    
    useEffect(()=>{
        //console.log("selectedSampleTypes",selectedSampleTypes);
    },[selectedSampleTypes])
    
    return (
        <Modal show={show} centered  onHide={handleModalClose}  >
            <Modal.Body  >
        <Loader loading={loading}/>

                <div>
                    
                    {type == 'donor' && (<><h3>Invite User</h3></>)}
                    <label htmlFor="donor_id_email" className="form-label">{type == 'donor' ? 'Recruit this donor to the following job' : 'Donor ID or Email'}{type !== 'donor' && <span className="text-red">*</span> }</label>
                    <div className="input-group">
                    <input type='text' name="donor_id_email" value={donorInput} onChange={(e) => {setDonorInput(e.target.value); setShowError(null); setDonorDetails(null);}} placeholder={`Search ${type === 'donor' ? 'by Job Number' : ''}`} className="form-control"></input>
                    <button
                        type="button"
                        className="btn btn-primary bg-orange"
                        onClick={() => searchDonorByIdorEmail(donorInput)}
                    >
                        <FaSearch/>
                    </button> 
                    </div>
                </div>

                <div className="text-danger mt-3">{showError}</div>
                {donorDetails && (
                    <>  
                    {type !== 'donor' && (<>
                        <DetailItem
                            title="User ID"
                            detail={donorDetails.donor_id || '-'}
                        />
                        <DetailItem
                            title="Email Address"
                            detail={donorDetails.email || '-'}
                        />
                        <DetailItem
                            title="Phone Number"
                            detail={donorDetails.phone_number || '-'}
                        />
                        <DetailItem
                            title="Biological Sex"
                            detail={donorDetails.gender || '-'}
                        />
                        {donorDetails?.race_data && donorDetails.race_data.length > 0 && (
                            <DetailItem 
                                // title={donorData.race_data[0]?.type_id === 1 ? 'Single Heritage' : 'Dual Heritage'} 
                                title={donorDetails.race_data[0]?.type_name} 
                                detail={donorDetails.race_data.map(race => race.heritage_name).join(', ')} 
                            />
                        )}
                    </>)}
                        <DetailItem
                            title="Sample Types"
                        />
                    
                        <div className='d-flex'>
                            {
                                sampleTypes?.length > 0 ? (
                                    donorDetails?.sample_ids?.some((sampleId) =>
                                        sampleTypes.some((sampleType) => `${sampleType.id}` === `${sampleId}`)
                                    ) ? (
                                        sampleTypes.map((sampleType) => {
                                            // Check if this sampleType exists in donorDetails.sample_ids
                                            const isUserSample = donorDetails?.sample_ids?.some(
                                                (sampleId) => `${sampleType.id}` === `${sampleId}`
                                            );

                                            return isUserSample ? (
                                                <React.Fragment key={sampleType.id}>
                                                    <div className='el-sample-tyep mb-2'>
                                                        <div className="el-checkbox-wrap">
                                                            <input
                                                                type="checkbox"
                                                                name="samplecheck[]"
                                                                value={sampleType.id}
                                                                className="samplecheck"
                                                                onChange={() => handleSampleTypeChange(sampleType.id)}
                                                                checked={selectedSampleTypes.includes(sampleType.id)}
                                                            />

                                                            <button
                                                                className={`btn bg-${sampleType.divClass} text-white el-sample-btn btn btn-flat jj-btn-sample-Blood mr-2 mb-2`}
                                                            >
                                                                <i className={sampleType.className}></i> {sampleType.label}
                                                            </button>
                                                        </div></div>
                                                    <span className="ms-2"></span>
                                                </React.Fragment>
                                            ) : null;
                                        })
                                    ) : (
                                        <p>No samples available</p>
                                    )
                                ) : (
                                    <p>No samples available</p>
                                )
                            }
                        </div>
                    </>
                )}
                <div className="d-flex my-3 w-f-content justify-content-center">
                    {(  donorDetails) && (<>
                        <button variant="outline-primary" className="el-main-button"
                            onClick={() => {
                                if((ismatched=="no" || donorDetails.matched_sample === "no" ) && selectedSampleTypes.length == 0){
                                    setShowError(`Please select at least one sample type ${type==='donor' && 'to assign'}`);
                                    
                                }
                                else if (ismatched=="no" && selectedSampleTypes.length > 0){
                                    onConfirm({ request_id: type ==='donor' ? donorDetails.id : id, donor_id:  type ==='donor' ? id :  donorDetails.id, sample_ids: selectedSampleTypes }); 
                                    handleModalClose();
                                }
                                else{ //matched and for donor Invite when ismatched is null
                                    // onConfirm({ request_id:  type ==='donor' ? donorDetails.id : id, donor_id:  type ==='donor' ? id :  donorDetails.id, sample_ids: (type ==='donor' && donorDetails.matched_sample == "no" ) ?  selectedSampleTypes :  donorDetails.sample_ids  });
                                    onConfirm({
                                        request_id: type === 'donor' ? donorDetails.id : id,
                                        donor_id: type === 'donor' ? id : donorDetails.id,
                                        sample_ids: 
                                            type === 'donor' && donorDetails.matched_sample === "no"
                                                ? selectedSampleTypes || []  // Ensure default to an empty array
                                                : donorDetails.sample_ids || [] // Ensure default to an empty array
                                    });  
                                    handleModalClose();
                                }
                            }}>
                            <span>  {type!=='donor'? ' Assign Donor' : 'Invite'}
                            </span>
                        </button>
                    </>
                    )}
                    {(showError || donorDetails) && ( 

                        <>
                            <button variant="outline-primary" className="back-link ms-3"  onClick={handleModalClose}>
                                Close
                            </button>
                        </>
                    )}  
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default InviteSpecialDonorModal;


 

const AutocompleteDonorID = ({  
  name,
  label,
  placeholder,  
  value,
  setFieldValue,
  allowInputChange, 
  id
}) => {

  const [exist, setExist] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [show, setShow] = useState(false); 
  const [activeIndex, setActiveIndex] = useState(0);
  const [disableTyping, setDisableTyping] = useState(false);
 
    
  useEffect(() => {
    if(!value) {
      setExist(false);
      setDisableTyping(false);
    }
  }, [value, exist, disableTyping]);


  const handleSuggestionClick = (value) => {    
    setFieldValue(value);
    setFiltered([]);
    setShow(false);        
    setExist(true);     
  };
  const handleInputChange = (e) => {
    if (disableTyping && e.nativeEvent.inputType !== "deleteContentBackward") return;
  
    // Update the actual value
    const inputValue = e.target.value;
    setFieldValue(inputValue); // Pass the actual input value to setFieldValue
    setFiltered([]);
    setShow(false);
  };
  

  const handleKeyDown = (e) => {
    if (disableTyping && e.key !== 'Backspace') return;

    if (e.key === 'Enter') {
      setFiltered([]);
      setShow(false);
    } else if (e.key === 'ArrowUp') {
      if (activeIndex > 0) setActiveIndex(activeIndex - 1);
    } else if (e.key === 'ArrowDown') {
      if (activeIndex < filtered.length - 1) setActiveIndex(activeIndex + 1);
    } else if (e.key === 'Backspace') {
      setExist(false);

      if(allowInputChange == false){
        setDisableTyping(false);
      }
    }
  };

  const fetchData = async () => {
    try {      
      if(value) {
        const results = await SampleService.getDonors(
            { request_id: id,
            search_text: value}
        );      
        setFiltered(results.donors || []);

        if (results.donors.length > 0 && (!exist || !value)) {
   
            setShow(true);  
        
        }
      }
      
    } catch (error) {
      setFiltered([]);
      setShow(false);
      console.error("Error while fetching", error);
    }
  };

  useEffect(() => {   
    if (!disableTyping) {
      const debounceTimeout = setTimeout(fetchData, 300);
      return () => clearTimeout(debounceTimeout);
    }    
  }, [value, disableTyping]); 

  return (
    <div className="autocomplete-container">
      <label htmlFor={name} className="form-label">
        {label}      <span className="text-red">*</span>
      </label>

      <div className="input-group d-flex">
        <div>
        <i className="search-icon el-icon-people"></i>
        <input
          type="text"
          name={name}
          className="autocomplete-input form-control"
          onKeyDown={handleKeyDown}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={value || ''} // Ensure each field has its own value
          autoComplete="off"
        />
        </div>
        <button
            type="button"
            className="btn btn-primary"
            onClick={() => setFieldValue(value)}
        >
            <FaSearch/>
        </button>
      </div>

      {filtered && show && value && (
        <div className="autocomplete-dropdown">
          {filtered.length > 0 &&
            filtered.map((suggestion, index) => (
              <div
                key={`${name}-${index}`}  
                className={`autocomplete-item ${index === activeIndex ? 'active' : ''}`}
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion}
              </div>
            ))}
        </div>
      )}
 
    </div>
  );
};
